import { render, staticRenderFns } from "./PrivilegeListPanel.vue?vue&type=template&id=639e1ede&scoped=true"
import script from "./PrivilegeListPanel.vue?vue&type=script&lang=js"
export * from "./PrivilegeListPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e1ede",
  null
  
)

export default component.exports